"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasOwnProperty = void 0;
var hasOwnProperty_1 = require("./hasOwnProperty");
Object.defineProperty(exports, "hasOwnProperty", { enumerable: true, get: function () { return hasOwnProperty_1.hasOwnProperty; } });
//# sourceMappingURL=index.js.map